(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.af = {}));
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var Afrikaans = {
      weekdays: {
          shorthand: ["So.", "Ma.", "Di.", "Wo.", "Do.", "Vr.", "Sa."],
          longhand: [
              "Sondag",
              "Maandag",
              "Dinsdag",
              "Woensdag",
              "Donderdag",
              "Vrydag",
              "Saterdag",
          ],
      },
      months: {
          shorthand: [
              "Jan",
              "Feb",
              "Mrt",
              "Apr",
              "Mei",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Okt",
              "Nov",
              "Des",
          ],
          longhand: [
              "Januarie",
              "Februarie",
              "Maart",
              "April",
              "Mei",
              "Junie",
              "Julie",
              "Augustus",
              "September",
              "Oktober",
              "November",
              "Desember",
          ],
      },
      ordinal: function (nth) {
          var s = nth % 100;
          if (s == 1 || s == 8 || s > 19)
              return "ste";
          return "de";
      },
      weekAbbreviation: "Wk",
      rangeSeparator: " tot ",
      scrollTitle: "Rol om te verander",
      toggleTitle: "Kliek om te wissel",
      yearAriaLabel: "Jaar",
      monthAriaLabel: "Maand",
      hourAriaLabel: "Uur",
      minuteAriaLabel: "Minuut",
      time_24hr: false,
      firstDayOfWeek: 0,
  };
  fp.l10ns.af = Afrikaans;
  var af = fp.l10ns;

  exports.Afrikaans = Afrikaans;
  exports.default = af;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
